import type { FC, PropsWithChildren } from "react";
import classes from "../../styles/NewTable.module.css";

export type TableButtonProps = PropsWithChildren<{
  icon: string;
  variant?: "normal" | "danger";
  tooltip?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  tableButtonStyle?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
}>;

const TableButton: FC<TableButtonProps> = (props) => {
  return (
    <button
      type="button"
      className={
        props.variant === "danger"
          ? classes.table__button_delete
          : classes.table__button
      }
      style={props.tableButtonStyle}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <svg
        className={
          props.variant === "danger"
            ? classes.table__button_delete_icon
            : classes.table__button_icon
        }
        style={props.iconStyle}
      >
        <use xlinkHref={`/assets/sprite.svg#icon-${props.icon}`} />
      </svg>
      {props.tooltip && (
        <p className={classes.table__button_tooltip}>{props.tooltip}</p>
      )}
    </button>
  );
};

export default TableButton;
